import React from 'react';

import PopularArticles from '../containers/PopularArticles';
import PromptContainer from '../containers/PromptContainer';
import TopicList from '../containers/TopicList';
import ChatBot from '../../contactUs/components/ChatBot';
import Page from '../../lib/page';

const HomePage = () =>
  <div className="home-content-container">
    <PopularArticles />
    <div className="topic-list__grid">
      <TopicList />
    </div>
    <div className="prompt-container__grid">
      <PromptContainer />
    </div>
    {Page.isHelpCenterHomePageChatEligible() &&
    <ChatBot link="smarthelp-chat-bot-home" id="chatBotHome" topicRefId="GENPOOL|homePage" display /> }
  </div>;

export default HomePage;
